/*** IMPORTS FROM imports-loader ***/
var define = false;

import SimpleFadeGallery from './SimpleFadeGallery'

const loadVisionUnobstructedSlider = () => {
    const visionUnobstructedSlider = new SimpleFadeGallery(document.querySelector('.vision-unobstructed-gallery'))
    visionUnobstructedSlider.init()
}

export default loadVisionUnobstructedSlider




// WEBPACK FOOTER //
// ./js/visionUnobstructedSlider.js